import api from './index';
//
let exports = {};

// 商品换货原因列表
exports.getGoodsExchgCauseList = function (postData, callback) {// 获取商品换货原因列表
    api.post('/goodsOper/esxchg/cause/list')
    .data(postData)
    .done(callback)
    .go();
};

// 商品退货原因列表
exports.getGoodsReturnCauseList = function (postData, callback) {// 获取商品退货原因列表
    api.post('/goodsOper/return/cause/list')
    .data(postData)
    .done(callback)
    .go();
};

// ==================================== 设备故障类型维护 =========================

exports.getDeviceFaultTypeList = function (data, callback) {    // 获取某分类下的故障类型
    api.post('/goodsOper/device/fault/type/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getDeviceFaultType = function (params, callback) {    // 根据id 获取 故障类型
    api.get('/goodsOper/device/fault/type/get')
    .params(params)
    .done(callback)
    .go();
};

exports.saveDeviceFaultType = function (data, callback) {    // 保存 故障类型
    api.post('/goodsOper/device/fault/type/save')
    .data(data)
    .done(callback)
    .go();
};

exports.updateDeviceFaultType = function (data, callback) {    // 更新 故障类型
    api.post('/goodsOper/device/fault/type/update')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteDeviceFaultType = function (params, callback) {    // 删除 故障类型
    api.post('/goodsOper/device/fault/type/delete')
    .params(params)
    .done(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsOper.js
// module id = 137
// module chunks = 1